window.peSocialProofData = [
  { name: "Marys", city: "Río Grande", baseMinutes: 6 },
  { name: "Muriel", city: "Rada Tilly", baseMinutes: 14 },
  { name: "Alejandro", city: "General Pico", baseMinutes: 3 },
  { name: "Franco", city: "Zárate", baseMinutes: 22 },
  { name: "Mariela", city: "La Lucila", baseMinutes: 9 },
  { name: "Gustavo", city: "CABA", baseMinutes: 17 },
  { name: "Roberto", city: "Arribeños", baseMinutes: 5 },
  { name: "Silvia", city: "José C. Paz", baseMinutes: 28 },
  { name: "Rosana", city: "CABA", baseMinutes: 11 },
  { name: "Carlos", city: "Buenos Aires", baseMinutes: 33 }
];
